(() => {
  const calendarMinimum = (parts, months) => {
    const lastDay = new Date(Date.UTC(parts.year, parts.month - 1 + months + 1, 0)).getUTCDate();
    const target = new Date(Date.UTC(parts.year, parts.month - 1 + months, Math.min(parts.day, lastDay)));
    return target.toISOString().slice(0, 10);
  };
  const todayInStudio = () => {
    const values = {};
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: 'numeric', day: 'numeric' })
      .formatToParts(new Date()).forEach(part => { if (part.type !== 'literal') values[part.type] = Number(part.value); });
    return values;
  };
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    if (!form || !form.querySelector('[data-field="event_type"]')) return;
    const field = name => form.querySelector('[data-field="' + name + '"]');
    const selectedKey = input => input?.selectedOptions?.[0]?.dataset.key || input?.value || '';
    const event = field('event_type');
    const eventDate = field('event_date');
    const eventFields = form.querySelector('[data-event-fields]');
    const unknown = form.querySelector('[data-event-unknown]');
    const ready = field('ready_date');
    const flexible = form.querySelector('[data-flexible]');
    const phone = field('phone');
    const units = field('units');
    form.querySelector('[data-flexible-wrap]').hidden = false;
    const update = () => {
      const kind = selectedKey(event);
      const bridal = kind === 'bridal' || kind === 'bridesmaids';
      const months = bridal ? 6 : 2;
      const minimum = calendarMinimum(todayInStudio(), months);
      const hasEvent = kind !== '' && kind !== 'wardrobe';
      root.querySelector('[data-timing="standard"]').hidden = bridal;
      root.querySelector('[data-timing="bridal"]').hidden = !bridal;
      const dateLabel = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' })
        .format(new Date(minimum + 'T12:00:00Z'));
      root.querySelector('[data-earliest-text]').textContent = root.dataset.earliest.replace('[date]', dateLabel);
      eventFields.hidden = !hasEvent;
      field('event_location').disabled = !hasEvent;
      unknown.disabled = !hasEvent;
      eventDate.disabled = !hasEvent || unknown.checked;
      eventDate.required = hasEvent && !unknown.checked;
      form.querySelector('[data-event-unknown-note]').hidden = !unknown.checked;
      ready.disabled = flexible.checked;
      ready.required = !flexible.checked;
      for (const date of [eventDate, ready]) {
        date.min = minimum;
        date.setCustomValidity('');
        if (!date.disabled && date.value && date.value < minimum) {
          date.setCustomValidity(root.dataset.dateError.replace('[months]', String(months)));
        }
      }
      if (!ready.disabled && !eventDate.disabled && ready.value && eventDate.value && ready.value > eventDate.value) {
        ready.setCustomValidity(root.dataset.eventError);
      }
      phone.required = ['phone', 'text'].includes(selectedKey(field('contact_method')));
      if (units) units.required = Array.from(form.querySelectorAll('[data-measurement]')).some(input => !input.disabled && input.value !== '');
      form.querySelectorAll('[data-required-mark]').forEach(mark => {
        const input = document.getElementById(mark.closest('label').htmlFor);
        mark.hidden = !input?.required || input.disabled;
      });
    };
    form.addEventListener('change', update);
    form.addEventListener('input', update);
    form.addEventListener('focusin', update);
    form.addEventListener('invalid', event => {
      const details = event.target.closest('details');
      if (details) details.open = true;
    }, true);
    form.addEventListener('submit', event => {
      update();
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
      }
    });
    update();
  };
  const initializeAll = parent => parent.querySelectorAll('[data-vm-commission]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document));
  else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
